import React, { PureComponent } from 'react';
import { Breadcrumb, BreadcrumbItem, Container, Row } from 'reactstrap';
import { omit } from 'underscore';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import cx from 'classnames';
import URI from 'urijs';

// components
import Paginator from '../../components/paginator/paginator';

// ducks
import { paginateThis, sortFields, MEMBER_TYPE_MAP } from '../../ducks/AgentSearch';

// middleware
import { cleanQuery } from '../../middleware/client';

// containers
import AgentSearchResults from './AgentSearchResults';
import AgentSearchForm from './AgentSearchForm';
// import AgentSearchFilterModal from "./AgentSearchFilterModal";

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';

class AgentSearch extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  render() {
    const {
      query,
      location: { pathname },
      hideBreadcrumb
    } = this.props;
    const { handleChange, handleSubmit } = this;
    const initialValues = omit(query, 'page', 'pageSize');
    const linkQuery = cleanQuery(query);
    const memberType = initialValues.memberType || this.props.memberType;
    const searchTo = URI(this.props.pathname)
      .search({
        memberType: memberType !== 'realtor' ? memberType : undefined
      })
      .toString();

    return (
      <Container fluid className={styles.AgentSearch}>
        {!hideBreadcrumb && (
          <Container>
            <Row>
              <Breadcrumb>
                <LinkContainer exact to="/">
                  <BreadcrumbItem>
                    <Link to="/">Home</Link>
                  </BreadcrumbItem>
                </LinkContainer>
                <LinkContainer exact to={searchTo}>
                  <BreadcrumbItem active>
                    Find a {MEMBER_TYPE_MAP[memberType].label}
                  </BreadcrumbItem>
                </LinkContainer>
              </Breadcrumb>
            </Row>
          </Container>
        )}
        <AgentSearchForm
          enableReinitialize={true}
          initialValues={initialValues}
          onFilterClick={() => {
            this.setState({
              showModal: true
            });
          }}
          onChange={handleChange}
          onSubmit={handleSubmit}
          basePath={pathname}
        />

        <Row className={cx(styles.searchPagination, BS.pt3)}>
          <Container>
            <Paginator
              listId="agents"
              to={pathname}
              query={linkQuery}
              sortFields={sortFields}
              top
            />
          </Container>
        </Row>
        <AgentSearchResults listId="agents" />
        <Row className={cx(styles.searchPagination, BS.pt3)}>
          <Container>
            <Paginator
              listId="agents"
              to={pathname}
              query={linkQuery}
              sortFields={sortFields}
              bottom
            />
          </Container>
        </Row>
      </Container>
    );
  }

  handleChange(values, dispatch, props, previousValues) {
    clearTimeout(this.onChangeSubmitTimeout);
    if (!props.pristine) {
      this.onChangeSubmitTimeout = setTimeout(() => {
        props.submit();
      }, 100);
    }
  }

  handleSubmit(values, dispatch, props) {
    const {
      submitSearch,
      location: { pathname }
    } = this.props;

    return submitSearch({
      to: pathname,
      values: values
    });
  }

  componentWillUnmount() {
    this.props.clearResults();
  }

  componentDidUpdate(prevProps) {
    const prevPathname = prevProps.location.pathname,
      pathname = this.props.location.pathname,
      memberType = this.props.query.memberType,
      oldMemberType = prevProps.query.memberType;

    if (this.props.query.page !== prevProps.query.page) {
      window.scrollTo(0, 0);
    }

    if (oldMemberType !== memberType) {
      this.props.resetResults([]);
    }

    if (
      prevPathname === this.props.pathnameAdvanced &&
      (pathname === this.props.pathnameAdvancedResults ||
        pathname === this.props.pathname)
    ) {
      this.props.expire();
    }
  }
}

const AgentSearchDecorated = paginateThis.decorate(AgentSearch, (state, props) => {
  return {
    memberType: props.memberType,
    agentName: '',
    officeId: '',
    address: '',
    firm: props.firm || '',
    designation: '',
    language: '',
    categoryId: '',
    name: ''
  };
});

AgentSearchDecorated.defaultProps = {
  pathname: '/find-naples-agent',
  pathnameAdvanced: '/find-naples-agent/advanced',
  pathnameAdvancedResults: '/find-naples-agent/advanced/results',
  memberType: 'realtor'
};

export default AgentSearchDecorated;



// WEBPACK FOOTER //
// ./src/containers/AgentSearch/AgentSearch.js